module.exports = __webpack_public_path__ + "static/m4buya-9068ed8cff3988a47c2c7880a8bb387a.png";